"use strict";

import ReactDOM from 'react-dom';
import React from 'react';

import { _I_, defineSimpleTerm } from 'components/locs';
import ApplicationEvents from 'components/applicationEvents';
import MoneyUtil from 'components/moneyUtil';


LogStream.enable("VIEWTRADEDIALOG");


function formatPreffered(normalPrice, localPrice, currency)  {
  return MoneyUtil.formatMoney(
      MoneyUtil.preferMoney(normalPrice, localPrice, currency),
      currency
    );
}


class DealEventTickerEntry  extends React.Component  {
  render()  {
    const  {  normalPrice,  localPrice,  currency,  buyer,  seller  } = this.props;
    const price = formatPreffered(normalPrice, localPrice, currency);
    return (
        <div>
          <b>{buyer}</b> {
              _I_("DealEventTickerEntry.purchasedFrom")
          } <b>{seller}</b> {
              _I_("DealEventTickerEntry.for")
          } {price}
        </div>
      );
  }
}


class BookSellTickerEntry  extends React.Component  {
  render()  {
    const  {  normalPrice,  localPrice,  currency,  userNick,  } = this.props;
    const price = formatPreffered(normalPrice, localPrice, currency);
    return (
        <div>
          <b>{userNick}</b> {_I_("BookSellTickerEntry.listedItem")} {price}
        </div>
      );
  }
}


class BookBuyTickerEntry  extends React.Component  {
  render()  {
    const  {  normalPrice,  localPrice,  currency,  userNick,  amount,  } = this.props;
    const price = formatPreffered(normalPrice, localPrice, currency);
    return (
        <div>
          <b>{userNick}</b> {_I_("BookBuyTickerEntry.created")} {amount} {_I_("BookBuyTickerEntry.for")} {price}
        </div>
      );
  }
}



export default class ViewTradeTickerLog extends React.Component  {
  constructor(props)  {
    super(props);

    const tickerEvents = Array( this.props.limitTickerLog ).fill(  <div>&nbsp;</div>  );
          tickerEvents[0] = (<div>{_I_("ViewTradeTickerLog.waiting")}</div>);
    this.state = {  tickerEvents  };

    this.onTickerEvent = (...rest) =>  this.onTickerEvent__(...rest)
  }


  static processBookEventRecord(bookRecord)  {
    const logType = bookRecord.lt;
    if (logType == 'SET')  {
      const orderType = bookRecord.ot;
      if (orderType == 'SELL')
        return (<BookSellTickerEntry normalPrice={bookRecord.normalPrice}
                                    localPrice={bookRecord.localPrice}
                                    currency={bookRecord.currency}
                                    userNick={bookRecord.user.nick}  />);

      if (orderType == 'BUY')
        return <BookBuyTickerEntry  normalPrice={bookRecord.normalPrice}
                                    localPrice={bookRecord.localPrice}
                                    amount={bookRecord.amount}
                                    currency={bookRecord.currency}
                                    userNick={bookRecord.user.nick}  />;
    }
  }


  onTickerEvent__( args, kwargs, details )  {
    const topic = details.decodedTopic;
    if ( !topic )                                         return;
    if ( this.props.market_name != topic.hashname )       return;
    if ( this.props.appid != topic.appId )                return;

    let events = [];
    if (topic.eventType == "deal")
      events.push(
          <DealEventTickerEntry normalPrice={kwargs.normalPrice}
                                localPrice={kwargs.localPrice}
                                currency={kwargs.currency}
                                buyer={kwargs.buyer}
                                seller={kwargs.seller}  />
        );

    if (topic.eventType == "book")  {
      events.push(  ...(kwargs.changes || []).map( ViewTradeTickerLog.processBookEventRecord )  );
    }

    events = events.filter( (e) => !!e );
    if ( events.length )
      this.setState(
          (prevState, props) => ({
              "tickerEvents" : ([ ...prevState.tickerEvents,
                                  ...events ]).slice(-props.limitTickerLog)
            })
        );
  }


  componentDidMount()  {
    ApplicationEvents.on("market.notify.received", this.onTickerEvent );
  }


  componentWillUnmount()  {
    ApplicationEvents.off("market.notify.received", this.onTickerEvent );
  }


  render()  {
    const fn = (entry, key) => (<div className="view-market-ticker-entry" key={`i${key}`}>{entry}</div>);
    const items = this.state.tickerEvents.map( fn );
    return (<div className="view-market-ticker-root">{items}</div>);
  }
}


defineSimpleTerm( "DealEventTickerEntry.purchasedFrom",  "purchased this item from",       {
  "ru_RU": "купил у",
  "cs_CZ": "purchased this item from",
  "fr_FR": "acheté cet article à",
  "de_DE": "dieses Item wurde gekauft von",
  "it_IT": "oggetto acquistato da",
  "ko_KR": "다음으로부터 구매된 아이템입니다",
  "pl_PL": "kupiono przedmiot od",
  "pt_PT": "purchased this item from",
  "es_ES": "compró este artículo de",
  "zh_CN": "已购买此物品，来源为",
  "zh_TW": "已購買此物品，来源為"
} );

defineSimpleTerm( "DealEventTickerEntry.for",  "for",       {
  "ru_RU": "за",
  "cs_CZ": "for",
  "fr_FR": "pour",
  "de_DE": "für",
  "it_IT": "per",
  "ko_KR": "for",
  "pl_PL": "dla",
  "pt_PT": "for",
  "es_ES": "por",
  "zh_CN": "花费",
  "zh_TW": "花費"
} );

defineSimpleTerm( "BookSellTickerEntry.listedItem",  "listed this item for sale for",       {
  "ru_RU": "выставил на продажу по",
  "cs_CZ": "listed this item for sale for",
  "fr_FR": "a mis cet article en vente pour",
  "de_DE": "dieses Item wurde zum Verkauf gelistet für",
  "it_IT": "metti in listino vendita questo oggetto per",
  "ko_KR": "다음 가격에 판매된 아이템입니다",
  "pl_PL": "wystawiono na sprzedaż za",
  "pt_PT": "listed this item for sale for",
  "es_ES": "listaste este artículo en venta por",
  "zh_CN": "将此物品列为出售，价格为",
  "zh_TW": "將此物品列為銷售，價格為"
} );

defineSimpleTerm( "BookBuyTickerEntry.created",  "created",       {
  "ru_RU": "выставил",
  "cs_CZ": "created",
  "fr_FR": "créé",
  "de_DE": "erstellt",
  "it_IT": "creato",
  "ko_KR": "생성됨",
  "pl_PL": "stworzono",
  "pt_PT": "created",
  "es_ES": "creado",
  "zh_CN": "已创建",
  "zh_TW": "已創建"
} );

defineSimpleTerm( "BookBuyTickerEntry.for",  "buy orders for",       {
  "ru_RU": "ордер(а/ов) на покупку по",
  "cs_CZ": "buy orders for",
  "fr_FR": "ordres d'achat pour",
  "de_DE": "Aufträge kaufen für",
  "it_IT": "ordini d'acquisto per",
  "ko_KR": "다음 가격에 구매 주문하였습니다",
  "pl_PL": "polecenia kupna za",
  "pt_PT": "buy orders for",
  "es_ES": "comprar pedidos por",
  "zh_CN": "购买订单，价格为",
  "zh_TW": "購買訂單，價格為"
} );

defineSimpleTerm( "ViewTradeTickerLog.waiting",  "Waiting for new activity...",       {
  "ru_RU": "Ожидание активности...",
  "cs_CZ": "Waiting for new activity...",
  "fr_FR": "En attente d'une nouvelle action ...",
  "de_DE": "Auf neue Aktivität warten...",
  "it_IT": "In attesa di una nuova attività...",
  "ko_KR": "새 거래 활동을 대기중입니다...",
  "pl_PL": "Oczekiwanie na aktywność...",
  "pt_PT": "Waiting for new activity...",
  "es_ES": "Esperando nueva actividad...",
  "zh_CN": "正在等待新的行动…",
  "zh_TW": "正在等待新的行動..."
} );

